import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAcmComponent } from './simple-icons-acm.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAcmComponent ],
    exports:      [ SimpleIconsAcmComponent ],
    bootstrap:    []
})
export class SimpleIconsAcmModule {}
